goog.provide("shadow.js.shim.module$src$svg$wpp$content_actions$eye_on_svg$default");
shadow.js.shim.module$src$svg$wpp$content_actions$eye_on_svg$default = shadow.js.shim.module$src$svg$wpp$content_actions$eye_on_svg.default;
